import { render, staticRenderFns } from "./ManageAlerts.vue?vue&type=template&id=41f4cc63&scoped=true&"
import script from "./ManageAlerts.vue?vue&type=script&lang=js&"
export * from "./ManageAlerts.vue?vue&type=script&lang=js&"
import style0 from "./ManageAlerts.vue?vue&type=style&index=0&id=41f4cc63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f4cc63",
  null
  
)

export default component.exports